{
  "comment": "M7 S14 (owns): the first-hour hooks (spec §2.1–§2.2), Kell's nudges and hint ladder (§11) and the station refusals under Tethys retaliation (§9). firstHour: the first data core salvaged at the Harrow POI (home.harrowPoiId, never a key literal: keys carry the derelict seed, BUG-B1/D-345) carries coreLog; the first First Rush ruin visited carries ruinLog; any other generic core copies a log drawn deterministically from the core id among the unheld authored logs of its coreSources. harrowHook: the mining-path hook; the first ore receipt at a receiptStations station posts the Mutual Bulletin item, and an ore sale anywhere posts it from hourOneS game seconds on. nudges: Kell's one nudge per tier after afterOnlineDays online days at that tier, then a hint rung every hintEveryOnlineDays online days while the Logs screen has an open question. refusals: per §9 retaliation row, the owner factions, M4 template ids (empty = every station of those factions) and actions refused, with the operator's message (no reason given). Text placeholders until the naming and voice pass; numbers are placeholders for the balance pass (M7 spec §15 item 4).",
  "firstHour": {
    "coreLog": "evacuation.harrow_queue",
    "ruinLog": "settlement.first_ruin",
    "coreSources": ["derelictCore", "convoyWreck"]
  },
  "harrowHook": {
    "receiptStations": ["refinery"],
    "hourOneS": 3600,
    "headline": "Salvagers report old convoy transponders near the Harrow derelict",
    "source": "mutualBulletin",
    "severity": 1
  },
  "nudges": {
    "afterOnlineDays": 2,
    "hintEveryOnlineDays": 2,
    "maxTier": 4
  },
  "refusals": {
    "dockingRefused": {
      "factions": ["tethys"],
      "actions": ["dock", "sellWare", "buyWare", "sellComponent", "buyComponent", "contracts", "yardOrder"],
      "message": "Docking refused by order of the operator. No reason given."
    },
    "refinerySalesRefused": {
      "factions": ["tethys"],
      "templates": ["refinery", "export_terminal"],
      "actions": ["sellWare"],
      "message": "The buyer's desk has closed your account. No reason given."
    },
    "boardsClosed": {
      "factions": ["tethys", "varro_security"],
      "actions": ["contracts"],
      "message": "The contract board is closed to your registration."
    },
    "componentsRefused": {
      "factions": ["tethys"],
      "actions": ["sellComponent", "buyComponent"],
      "message": "The parts desk won't deal with your registration. No reason given."
    },
    "yardsRefused": {
      "factions": ["tethys"],
      "templates": ["yards"],
      "actions": ["yardOrder"],
      "message": "The yard has no slot for your registration. No reason given."
    }
  }
}
